import Marquee from 'react-fast-marquee';
// images 
import brand1 from '../../Assets/images/Brands/Frame 18.png';
import brand2 from '../../Assets/images/Brands/Frame 17.png';
import brand3 from '../../Assets/images/Brands/Frame 20.png';
import brand4 from '../../Assets/images/Brands/Frame 21.png';
import brand5 from '../../Assets/images/Brands/Frame 22.png';
import brand6 from '../../Assets/images/Brands/Frame 24.png';
import { Trans, useTranslation } from 'react-i18next';


export default function Customers({dir}) {
    const { t, i18n } = useTranslation();
      
      
    const brands = [
        { logo: brand1, name: 'Brand 1' },
        { logo: brand2, name: 'Brand 2' },
        { logo: brand3, name: 'Brand 3' },
        { logo: brand4, name: 'Brand 4' },
        { logo: brand5, name: 'Brand 5' },
        { logo: brand6, name: 'Brand 6' },
    ];

    return <>
        <div className='d-flex justify-content-center mb-5'>
            <h2 className="Title px-2 my-5  wow fadeInLeft" data-wow-delay="0.3s" >
             <div className='indicator'></div>
            <Trans i18nKey="CustomersTitle"> 
                عملاؤنا
            </Trans>
        </h2>
        </div>
        <div className="Brands">
            <Marquee speed={150} pauseOnHover={true}>
                {brands.map((brand, i) => (
                    <img src={brand.logo} className='Brand-img' alt={brand.name} key={i} />
                ))}
            </Marquee>
        </div>
    </>
};